module.exports = __webpack_public_path__ + "img/mission.8101fa7e.png";